import React, {useCallback, useEffect, useState} from 'react'
import classes from './style.module.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { unitPrice, getLowerPrice, getDelPrice, isPromotion, getProductUrl } from '../../../../../../utils/product'
import useStyles from 'isomorphic-style-loader/useStyles'
import withItemScroll from '../../../../../hocs/item-scroll'
import { useLocation } from 'react-router-dom'
import { useApp } from '../../../../../hooks/common'
import CartIcon, { BuyIcon } from '../../../../listing/components/cart/cart-icon'
import { Swiper, SwiperSlide } from 'swiper/react';
import { FormattedMessage } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants'
import { Iconfont } from '../../../../../components/icon/iconfont'


export const EmptyItem = props => {
	useStyles(classes)
	return <figure className={classes.SimpleItem}>
		<div>
			<div className={classes.Image}>
				<img alt="empty" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" />
			</div>
		</div>
		<figcaption>
			<div className={classes.Prices}>
				<span className={classes.Price} style={{ opacity: 0 }}>$</span>
			</div>
		</figcaption>
	</figure>
}

const ColorSwiper = props => {
	useStyles(classes)
	const {colors, selectedColor, onColor} = props
	const [spaceBetween, setSpaceBetween] = useState(0)

	const clickHandle = useCallback(color => {
		onColor(color)
	})

	useEffect(() => {
		const rem = 2 * 14 / 75
		const [topSize] = window.document.documentElement.style.fontSize.split('px')
		setSpaceBetween(topSize*rem)
	}, [])


	return <div className={classes.ColorSwiper}>
		<div>
			<Swiper
				onSlideChange={() => {}}
				onSwiper={(swiper) => {}}
				spaceBetween={14}
				slidesPerView={4}
			>
				{
					colors?.map((color, index) => <SwiperSlide className={classes.ColorSlide} key={index}>
						<span className={`${classes.ColorImage} ${color.productId === selectedColor?.productId?classes.Active:''}`} onClick={e => {clickHandle(color)}} >
							<LazyLoadImage src={color.colorImage} alt={color.color}/>
						</span>
					</SwiperSlide>)
				}
			</Swiper>
		</div>

	</div>
}


export default withItemScroll(props => {

	useStyles(classes)

	const location = useLocation()
	const isApp = useApp()

	const { product, position, column, sensors, isBeautyLook, noAction, data, openEditor, productSelect } = props
    const { variantId, selected } = data || {}
    const selectedVariant = product?.variants?.find(v => v.id == variantId) || product?.variants?.[0]	

	const [lowerPrice, delPrice, isProm] = [
		getLowerPrice(product),
		getDelPrice(product),
		isPromotion(product)
	]

	let off = 0
	if (delPrice) {
		off = Math.round((Number(delPrice.amount) - Number(lowerPrice.amount)) * 100 / Number(delPrice.amount))
	}
	const url = isApp ? `chic-me://chic.me/product?id=${selectedVariant?.id || product?.id}` : getProductUrl(selectedVariant?.id || product?.id, product?.name)

	const promotionType = isProm ? product.promotion.type : ''

	const isActivePromotion = isProm && !product?.promotion?.countdownHidden

	// const priceClass = isActivePromotion ? classes.FlashPrice : (off > 0 ? classes.PromotionPrice : classes.Price)
    const priceClass = delPrice ? classes.FlashPrice : classes.Price

    const beforeOpenEditor = () => {
        openEditor(product, selectedVariant, selectedVariant?.color)
    }

	return <figure className={`${classes.SimpleItem} ${classes.SimpleItemFlex}`}>
		<a ref={props?.innerRef} 
            product-id={product?.id}
            data-product-list-source
            data-promotion={promotionType}
            data-layer={product?.layerName}
            data-tracking={product?.trackingRecords}
            data-product-source={product?.dataSource}
            data-geeko-experiment={product?.geekoExperimentId}
            data-geeko-id={product?.geekoRequsestId}
            data-request-id={product?.aliRequestId}
            data-experiment-id={product?.aliExperimentId}
            data-column={column}
            data-product-position={position + 1}
            data-position={sensors?.resource_position}
            data-type={sensors?.resource_type}
            data-content={sensors?.resource_content}
            data-title={sensors?.resourcepage_title}
            href="javascript:;" 
            onClick={() => beforeOpenEditor()}>
			<div className={classes.Image}>
				<LazyLoadImage src={`${IMAGE_GEEKO_LTD}/medium/${selectedVariant?.mainImage || product?.pcMainImage}`} alt={product?.name} />
			</div>


			{
				location.pathname === '/i/black-friday' ? <React.Fragment>
					{
						off > 0 && <span className={classes.FestivalOff}>
							<span className={classes.Txt}>
								{`-${off}%`}
							</span>
						</span>
					}

				</React.Fragment> : <React.Fragment>
					{
						product?.flag ? (
							<span className={`${classes.OffTip} ${classes.PreFall}`}>{product.flag}</span>
						) : (
							<React.Fragment>
								{
									product?.isNew && <span className={classes.New}><FormattedMessage id="new" defaultMessage={'New'} /></span>
								}
			
								{
									isActivePromotion && <span style={{ backgroundColor: '#fed157', color: '#222' }} className={classes.OffTip}>{`-${off}%`}</span>
								}
			
			
								{
									!product?.isNew && !isActivePromotion && off > 0 && <span className={classes.OffTip}>{`-${off}%`}</span>
								}
							</React.Fragment>
						)
					}
				</React.Fragment>
			}
        </a>
		<figcaption>

			<div className={classes.Container}>
				<div className={classes.Prices}>
					<span className={priceClass}>{unitPrice(lowerPrice)}</span>
					{
						delPrice && <del className={classes.Del}>{unitPrice(delPrice)}</del>
					}
				</div>
				
			</div>

            <div className={classes.SizeChange} onClick={() => beforeOpenEditor()}>
                <div className={classes.SizeFont}>
                    <FormattedMessage id={"size"} defaultMessage="Size"/>:
                    {selectedVariant?.size2 || selectedVariant?.size || <FormattedMessage id={"one_size"} defaultMessage="One Size"/>}
                </div>
                <Iconfont className={classes.SizeChangeIcon} >&#xe694;</Iconfont>
            </div>
            {
                !noAction ?
                <div className={`${classes.SelectIconLine} ${selected && classes.SelectIconSelected}`} onClick={() => productSelect(variantId, !selected)}>
                    <Iconfont className={classes.SelectIcon} >&#xe6f0;</Iconfont>
                </div>:
                <div className={`${classes.SelectIconLine} ${classes.SelectIconMain}`}>
                    <Iconfont className={classes.SelectIcon} >&#xe6f0;</Iconfont>
                </div>
            }
            

			
		</figcaption>
	</figure>
})